/* 
 	* 指令下发组件 
 	* 描述：InsGT740WeekModeSet指令下发
 	* 创建时间：2017-07-27 
 	* 创建人：baixx 
*/
<template>
	<div>
		<form class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-3 control-label"><span class="red pr5px">*</span>星期</label>
			<div class="col-sm-9">
			    <span  class="pr15px">
				      <input type="checkbox" v-model="mon"/>
				      <label class="control-label"><div class="weight_n">周一</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="tue"/>
				      <label class="control-label"><div class="weight_n">周二</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="wed"/>
				      <label class="control-label"><div class="weight_n">周三</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="thu"/>
				      <label class="control-label"><div class="weight_n">周四</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="fri"/>
				      <label class="control-label"><div class="weight_n">周五</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="sat"/>
				      <label class="control-label"><div class="weight_n">周六</div></label>
				    </span>
					<span  class="pr15px">
				      <input type="checkbox" v-model="sun"/>
				      <label class="control-label"><div class="weight_n">周日</div></label>
				   </span></div>
				</div>
			<div class="form-group">
				<label class="col-sm-3 control-label">唤醒时间</label>
			    <div class="col-sm-6">
			        <input type="text" class="form-control" v-model="duration" placeholder="HH:MM"> 
			    </div>
		   </div>
		   <div class="form-group">
				<label class="col-sm-4 control-label"></label>
				<div class="col-sm-8">
					<span class="red pt5px">{{alertMsg}}</span>
				</div>
			</div>
		    <div class="form-group text-right pt10px pr10px">
		    	<button type="button" class="btn btn-primary modal-btn" @click="withdrawBtn">取消</button>
		    	<button type="button" class="btn btn-primary modal-btn" @click="nextClick">下一步</button>
		    </div>
		    
		</form>
   </div>	
</template>
<script>
	export default {
		name: "InsGT740WeekModeSet",
		data() {
			return {
				sat:0,
				fri:0,
				thu:0,
				wed:0,
				tue:0,
				mon:0,
				sun:0,
				duration:"",              //起始时间
				alertMsg:''
			};	
		},
		props:['from','delCmd'],
		watch:{
			delCmd(val){
				if(val){
					this.resetInput()
				}
			}
		},
		methods: {	
			resetInput(){
				this.duration = ''
				this.alertMsg = ''
			},
			withdrawBtn(){
				this.resetInput()
				if(this.from=='monitor'){
					this.$store.dispatch('instModalHide')
				}else{
					this.$emit('withdrawBtn')
				}
			},
			nextClick(){
				const that = this
				let r6 = this.sat || this.mon || this.tue || this.wed || this.thu || this.fri || this.sun
				let duration1 = /^(?:(?:0|1)\d|2[0-3]):[0-5]\d$/.test(that.duration)
				if(duration1){
						this.alertMsg = ''
					}else{
						this.alertMsg = '唤醒时间填写不正确'
						return
				}
				if(r6){
						this.alertMsg = ''
					}else{
						this.alertMsg = '请选择星期'
						return
				}	
				let str1  = this.mon?'1':'' 
				let str2 =  this.tue?'2':'' 
				let str3 =  this.wed?'3':'' 
				let str4 =  this.thu?'4':'' 
				let str5 =  this.fri?'5':'' 
				let str6 =  this.sat?'6':'' 
				let str7 =  this.sun?'7':''
				let str = str1 + str2 + str3 + str4 + str5 + str6 + str7 
				let arr = ["SETPRM","MODE",3, str, this.duration]
				if(this.from=='monitor'){
					this.$store.dispatch('getCmdInfo',arr)
				}else{
					this.$emit('nextClick',arr)
				}
		    }
	    }
	}
</script>



// WEBPACK FOOTER //
// InsGT740WeekModeSet.vue?8f47fc58